/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

global.$ = global.jQuery = require('jquery');

// npm dependencies
import 'bootstrap'
import 'bootstrap-table'
import 'bootstrap-table/dist/bootstrap-table-locale-all.min'
import 'select2'
import 'daterangepicker'
import 'lightbox2/dist/js/lightbox-plus-jquery'


// resources dependecies
import './vendors/vendors'
import '../pdait/pdait'
import './helpers/helpers'
import './theme'

// common.js for all domains
import '../common'
// custom.js
import './custom'


